/**
 * canvas で長辺 maxEdge の JPEG サムネを生成する (依存ゼロ、issue #23 確認ビュー用)。
 * createImageBitmap が decode できない形式 (一部ブラウザの HEIC 等) は null を返し、UI 側で
 * 「プレビュー不可」プレースホルダにフォールバックする (位置情報は別途 exifr が HEIC でも読める)。
 *
 * 注意: ここで生成するのは確認ビュー表示用サムネのみ。投稿に保存する原本/サムネの Storage
 * アップロード (EXIF 除去込み) は Phase D で別途行う。
 */
export async function generatePreviewThumbnail(
  file: File,
  maxEdge = 400,
  quality = 0.8,
): Promise<Blob | null> {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bitmap.close();
      return null;
    }
    ctx.drawImage(bitmap, 0, 0, w, h);
    bitmap.close();
    return await new Promise<Blob | null>((resolve) =>
      canvas.toBlob((b) => resolve(b), 'image/jpeg', quality),
    );
  } catch {
    return null;
  }
}
